/** @format */

const sectionNavigationItems = [
    {
        key: 'news',
        label: 'News',
        routeCandidates: ['news']
    },
    {
        key: 'videocasts',
        label: 'Videocasts',
        routeCandidates: ['videocasts']
    },
    {
        key: 'opinions',
        label: 'Opinions',
        routeCandidates: ['opinions', 'opinion']
    },
    {
        key: 'columns',
        label: 'Columns',
        routeCandidates: ['columns']
    },
    {
        key: 'newscasts',
        label: 'Newscasts',
        routeCandidates: ['newscasts']
    },
    {
        key: 'calendar',
        label: 'Calendar',
        routeCandidates: ['calendar', 'events']
    },
    {
        key: 'blotter',
        label: 'Blotter',
        routeCandidates: ['police-blotter', 'blotter']
    },
    {
        key: 'obituaries',
        label: 'Obituaries',
        routeCandidates: ['obituaries', 'obituary']
    },
    {
        key: 'public-notices',
        label: 'Public Notices',
        routeCandidates: ['public-notices']
    }
];

export const buildPrimarySectionNavigation = function (sections = []) {
    return sectionNavigationItems
        .map((item) => {
            const section = item.routeCandidates
                .map((routeCandidate) => {
                    return sections.find((section) => section.is_active && section.route === routeCandidate);
                })
                .find((section) => section !== undefined);

            return section
                ? {
                      ...section,
                      navLabel: item.label
                  }
                : null;
        })
        .filter((section) => section !== null);
};
